import { swiperAssetsDefaultConfig } from 'src/app/swiper/swiper.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DetailRoutingModule } from './detail-routing.module';
import { DetailComponent } from './component/detail/detail.component';
import { TranslateModule } from '@ngx-translate/core';
import { ShareModule } from '../share/share.module';
import { TechmoreSharedModule } from '@techmore/share';
import { SwiperModule, SWIPER_ASSETS } from '../swiper/swiper.module';
import { ShareDetailModule } from './share-detail.module';
import { DataSearchService } from '../data-search/data-search.service';
import { PhotoSwipeModule } from '@techmore/photo-swipe';
import { DownloadTooltipComponent } from './component/download-tooltip/download-tooltip.component';
import { NgxJsonLdModule } from 'ngx-json-ld';
import { ThreeDViewModule } from '../three-d-view/three-d-view.module';


/** 素材detail頁面模組 */
@NgModule({
  declarations: [
    DetailComponent,
    DownloadTooltipComponent,
  ],
  imports: [
    CommonModule,
    DetailRoutingModule,
    TranslateModule.forChild(),
    ShareModule,
    TechmoreSharedModule,
    SwiperModule,
    ShareDetailModule,
    SwiperModule,
    PhotoSwipeModule.forRoot(),
    NgxJsonLdModule,
    ThreeDViewModule,
  ],
  providers: [
    DataSearchService,
    { provide: SWIPER_ASSETS, useValue: swiperAssetsDefaultConfig },
  ]
})
export class DetailModule { }
